import { ApiResponse } from 'apisauce'
import { call, put } from 'redux-saga/effects'

import api from 'src/services/api'
import i18n from 'src/config/i18n'

import { ClientNotifyCatch } from 'src/config/bugsnag'
import findBasicApiResponseErrors from 'src/services/findBasicApiResponseErrors'

import { ResponseDataRequests } from './types'
import * as Actions from './actions'

export function* getGroupTrees({
  payload: { options }
}: ReturnType<typeof Actions.getGroupTrees>) {
  try {
    const response: ApiResponse<ResponseDataRequests> = yield call(
      api.get,
      `/role_group_trees?assign_tree_id=${
        options.assign_tree_id
      }&page_size=10&page=${options.page || 1}`
    )
    if (response.ok) {
      yield put(Actions.getGroupTreesSuccess(response.data))
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(Actions.getGroupTreesFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga getGroupTrees', err)
    const message = i18n.t('common.response.unexpected-error')
    yield put(Actions.getGroupTreesFailure(message))
  }
}

export function* sendGroupTrees({
  payload: { role_group_trees }
}: ReturnType<typeof Actions.sendGroupTrees>) {
  try {
    const response: ApiResponse<ResponseDataRequests> = yield call(
      api.post,
      `/role_group_trees`,
      { role_group_trees }
    )

    if (response.ok) {
      yield put(Actions.sendGroupTreesSuccess())
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(Actions.sendGroupTreesFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga sendGroupTrees', err)
    const message = i18n.t('common.response.unexpected-error')
    yield put(Actions.sendGroupTreesFailure(message))
  }
}
